import { render, staticRenderFns } from "./AddCode.vue?vue&type=template&id=1af38360&"
import script from "./AddCode.vue?vue&type=script&lang=js&"
export * from "./AddCode.vue?vue&type=script&lang=js&"
import style0 from "./AddCode.vue?vue&type=style&index=0&id=1af38360&prod&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports